import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils/apolloError";
import {
  GetOrgUserByOrganizationIdAndOrgUserId,
  GetOrgUserByOrganizationIdAndOrgUserIdVariables,
} from "./__generated__/GetOrgUserByOrganizationIdAndOrgUserId";
import { ORG_USER_FIELDS } from "../fragments/OrgUser";
import { CORE_LICENCE_FIELDS } from "../fragments/Licence";
import { CORE_PERMIT_REGISTER_FIELDS } from "../fragments/PermitRegister";

export const GET_ORG_USER_BY_ORGANIZATION_ID_AND_ORG_USER_ID = gql`
  ${ORG_USER_FIELDS}
  ${CORE_LICENCE_FIELDS}
  ${CORE_PERMIT_REGISTER_FIELDS}
  query GetOrgUserByOrganizationIdAndOrgUserId($organizationId: String!, $orgUserId: String!) {
    orgUserByOrganizationIdAndOrgUserId(organizationId: $organizationId, orgUserId: $orgUserId) {
      ...OrgUserFields
      orgUserFiles {
        id
        title
        expiryDate
        fileUrl
      }
      licenceId
      licence {
        ...CoreLicenceFields
      }
      adminRole {
        id
        name
      }
      registerAssignments {
        id
        permitRegister {
          ...CorePermitRegisterFields
          project {
            id
            name
          }
        }
        permitTypeOrgRole {
          id
          orgRole {
            id
            roleId
            displayName
            licenceType
          }
          permitType {
            id
            name
          }
        }
        orgUser {
          ...OrgUserFields
          licenceId
          licence {
            id
            productName
            type
          }
        }
        isDisabled
      }
    }
  }
`;

export function useLazyGetOrgUserByOrganizationIdAndOrgUserId() {
  const [getOrgUserByOrganizationIdAndOrgUserId, { loading, error, data }] = useLazyQuery<
    GetOrgUserByOrganizationIdAndOrgUserId,
    GetOrgUserByOrganizationIdAndOrgUserIdVariables
  >(GET_ORG_USER_BY_ORGANIZATION_ID_AND_ORG_USER_ID, {
    errorPolicy: "all",
    fetchPolicy: "cache-and-network",
  });

  return {
    getOrgUserByOrganizationIdAndOrgUserId,
    data,
    status: { loading, errors: getErrors(error), successful: !error && data ? true : false } as AsyncQueryStatus,
  };
}
